class AjaxSearch extends ajaxSearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.ajaxSearchResults = this.querySelector('[data-search-ajax]');
    this.allajaxSearchInstances = document.querySelectorAll('search-ajax');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchCond = '';
    this.ajaxEventListeners();

    // HG boost feed cache (session)
    this.hgFeedUrl = "/collections/all?view=hg-search";
    this.hgCacheKey = "hg_search_feed_v4";
    this.hgCacheTsKey = "hg_search_feed_ts_v4";
    this.hgCacheTtl = 6 * 60 * 60 * 1000; // 6h
  }

  ajaxEventListeners() {
    this.input.form.addEventListener('submit', this.ajaxFormSubmit.bind(this));
    this.input.addEventListener('focus', this.inputFocus.bind(this));
    this.addEventListener('focusout', this.inputFocusOut.bind(this));
    this.addEventListener('keyup', this.inputKeyup.bind(this));
    this.addEventListener('keydown', this.inputKeydown.bind(this));
  }

  ajaxgetInquiry() {
    return this.input.value.trim();
  }

  triggerChange() {
    super.triggerChange();
    const searchCondNew = this.ajaxgetInquiry();
    if (!this.searchCond || !searchCondNew.startsWith(this.searchCond)) {
      this.querySelector('#search-ajax-block')?.remove();
    }
    this.updateForCond(this.searchCond, searchCondNew);
    this.searchCond = searchCondNew;

    if (!this.searchCond.length) {
      this.close(true);
      return;
    }
    this.getAjaxResults(this.searchCond);
  }

  ajaxFormSubmit(event) {
    if (!this.ajaxgetInquiry().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  ajaxFormReset(event) {
    super.ajaxFormReset(event);
    if (super.shouldResetForm()) {
      this.searchCond = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.clearInput(true);
    }
  }

  inputFocus() {
    const currentSearchTerm = this.ajaxgetInquiry();
    if (!currentSearchTerm.length) return;
    if (this.searchCond !== currentSearchTerm) {
      this.triggerChange();
    } else if (this.getAttribute('results') === 'true') {
      this.ajaxOpen();
    } else {
      this.getAjaxResults(this.searchCond);
    }
  }

  inputFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  inputKeyup(event) {
    if (!this.ajaxgetInquiry().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.checkOption('up');
        break;
      case 'ArrowDown':
        this.checkOption('down');
        break;
      case 'Enter':
        this.menuOption();
        break;
    }
  }

  inputKeydown(event) {
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateForCond(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-search-ajax-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      const matches = currentButtonText.match(new RegExp(previousTerm, 'g'));
      if (matches && matches.length > 1) return;
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  checkOption(direction) {
    if (!this.getAttribute('open')) return;
    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.search-ajax__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;
    if (moveUp && !selectedElement) return;
    let selectedElementIndex = -1;
    let i = 0;
    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }
    this.statusElement.textContent = '';
    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }
    if (activeElementIndex === selectedElementIndex) return;
    const activeElement = allVisibleElements[activeElementIndex];
    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  menuOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
    if (selectedOption) selectedOption.click();
  }

  // ---------------------------
  // HG BOOST helpers (descriere/tags)
  // ---------------------------
  hgStripDiacritics(str) {
    return String(str || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/ș/g, "s").replace(/Ş/g, "s")
      .replace(/ț/g, "t").replace(/Ţ/g, "t")
      .replace(/ă/g, "a").replace(/Ă/g, "a")
      .replace(/â/g, "a").replace(/Â/g, "a")
      .replace(/î/g, "i").replace(/Î/g, "i");
  }

  hgNorm(str) {
    return this.hgStripDiacritics(str)
      .toLowerCase()
      .replace(/\u00A0/g, " ")
      .replace(/[^\p{L}\p{N}\s-]/gu, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  hgTokens(q) {
    const n = this.hgNorm(q);
    if (!n) return [];
    return n.split(" ").filter(Boolean).slice(0, 8);
  }

  hgScore(p, tokens) {
    const title = this.hgNorm(p.title);
    const tags = this.hgNorm(p.tags);
    const text = this.hgNorm(p.text);

    let score = 0;
    for (const t of tokens) {
      if (!t) continue;

      if (title.includes(t)) score += 6;
      if (tags.includes(t)) score += 4;
      if (text.includes(t)) score += 2;

      if (t.length >= 4) {
        const stem = t.slice(0, t.length - 1);
        if (stem && title.includes(stem)) score += 1;
        if (stem && tags.includes(stem)) score += 1;
        if (stem && text.includes(stem)) score += 1;
      }
    }
    if (score > 0) score += Math.min(tokens.length, 4);
    return score;
  }

  async hgFetchFeed() {
    const now = Date.now();
    try {
      const ts = Number(sessionStorage.getItem(this.hgCacheTsKey) || "0");
      const cached = sessionStorage.getItem(this.hgCacheKey);
      if (cached && ts && now - ts < this.hgCacheTtl) {
        const parsed = JSON.parse(cached);
        if (Array.isArray(parsed)) return parsed;
      }
    } catch (e) {}

    const res = await fetch(this.hgFeedUrl, { credentials: "same-origin" });
    if (!res.ok) throw new Error("HG feed failed");
    const data = await res.json();

    try {
      sessionStorage.setItem(this.hgCacheKey, JSON.stringify(data));
      sessionStorage.setItem(this.hgCacheTsKey, String(now));
    } catch (e) {}
    return Array.isArray(data) ? data : [];
  }

  hgBuildBoostMarkup(products, term) {
    if (!products || !products.length) return "";

    const items = products.map((p) => {
      const img = p.image
        ? `<img src="${p.image}" alt="${this.hgEscape(p.title)}" loading="lazy" decoding="async">`
        : "";

      const price = (window.Shopify && Shopify.formatMoney && window.money_format && typeof p.price !== "undefined")
        ? Shopify.formatMoney(p.price, window.money_format)
        : "";

      const compare = (window.Shopify && Shopify.formatMoney && window.money_format && p.compare_at_price && p.compare_at_price > p.price)
        ? Shopify.formatMoney(p.compare_at_price, window.money_format)
        : "";

      return `
        <li class="grid-wrapper hg-boost-item">
          <div class="single-product-wrap ${p.available ? "" : "stock-out"}">
            <div class="product-image ${p.available ? "" : "stock-out"}">
              <a class="pro-img" href="${p.url}">
                <div class="img1">${img}</div>
              </a>
            </div>
            <div class="product-content">
              <a href="${p.url}" title="${this.hgEscape(p.title)}">${this.hgEscape(p.title)}</a>
              <div class="price-box">
                ${price ? `<span class="new-price">${price}</span>` : ""}
                ${compare ? `<span class="old-price">${compare}</span>` : ""}
              </div>
            </div>
          </div>
        </li>
      `;
    }).join("");

    return `
      <div class="ajax-result-group hg-boost-group">
        <div class="product-list">
          <div class="hg-boost-head">
            <h6 class="list-title">Rezultate din descriere</h6>
            <span class="hg-boost-sub">pentru „${this.hgEscape(term)}”</span>
          </div>
          <ul class="grid-wrap">
            ${items}
          </ul>
        </div>
      </div>
    `;
  }

  hgEscape(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  async hgAppendBoostToMarkup(resultsMarkup, term) {
    const t = (term || "").trim();
    if (t.length < 2) return resultsMarkup;

    let feed = [];
    try {
      feed = await this.hgFetchFeed();
      console.log("[HG BOOST] feed products:", feed.length, "term:", term);
    } catch (e) {
      return resultsMarkup;
    }

    const tokens = this.hgTokens(t);
    if (!tokens.length) return resultsMarkup;

    // produsele deja afisate de predictive (ca sa nu duplicam)
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div id="hg-wrap">${resultsMarkup}</div>`, "text/html");
    const existingLinks = Array.from(doc.querySelectorAll('a[href*="/products/"]'))
      .map(a => a.getAttribute("href"))
      .filter(Boolean);
    const existingSet = new Set(existingLinks);

    const scored = feed
      .map(p => ({ p, s: this.hgScore(p, tokens) }))
      .filter(x => x.s > 0 && !existingSet.has(x.p.url))
      .sort((a, b) => b.s - a.s)
      .slice(0, 8)
      .map(x => x.p);

    console.log("[HG BOOST] scored:", scored.length, scored.slice(0, 3));
    if (!scored.length) return resultsMarkup;

    const root = doc.querySelector("#hg-wrap");
    const boostHtml = this.hgBuildBoostMarkup(scored, t);
    if (boostHtml) root.insertAdjacentHTML("beforeend", boostHtml);

    return root.innerHTML;
  }

  // ---------------------------
  // Existing flow + HG boost
  // ---------------------------
  getAjaxResults(searchCond) {
    const queryKey = searchCond.replace(' ', '-').toLowerCase();
    this.ajaxLoader();

    if (this.cachedResults[queryKey]) {
      this.ajaxSendresult(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${routes.ajax_search_url}?q=${encodeURIComponent(searchCond)}&section_id=search-ajax`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const baseMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-search-ajax').innerHTML;

        return this.hgAppendBoostToMarkup(baseMarkup, searchCond);
      })
      .then((finalMarkup) => {
        this.allajaxSearchInstances.forEach((inst) => {
          inst.cachedResults[queryKey] = finalMarkup;
        });

        this.ajaxSendresult(finalMarkup);

        // keep old handler (variant image/price updates on click)
        $('.item-data').on("click", function () {
          $(this).parents('.option-block').find(".variant-option").removeClass('active-variant');
          $(this).closest('form-wrap').addClass('active-variant');
          var it_img = $(this).attr('dataimg');
          $(this).parents('.single-product-wrap').find('.product-image .img1 img').attr('src', it_img);
          $(this).parents('.single-product-wrap').find('.product-image .img1 img').attr('srcset', it_img);
          var price = $(this).attr('dataprice');
          var compareprice = $(this).attr('datacompare');
          $(this).parents('.single-product-wrap').find('.price-box .new-price').text(Shopify.formatMoney(price, window.money_format));
          if (compareprice > price) {
            $(this).parents('.single-product-wrap').find('.price-box .old-price').show();
            $(this).parents('.single-product-wrap').find('.price-box .old-price').html(Shopify.formatMoney(compareprice, window.money_format));
          } else {
            $(this).parents('.single-product-wrap').find('.price-box .old-price').hide();
          }
        });
      })
      .catch((error) => {
        if (error?.code === 20) return;
        this.close();
        throw error;
      });
  }

  ajaxLoader() {
    this.statusElement = this.statusElement || this.querySelector('.search-ajax-status');
    this.setAttribute('loading', true);
  }

  ajaxInputText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  ajaxSendresult(resultsMarkup) {
    this.ajaxSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.sendInputresult();
    this.ajaxOpen();
  }

  sendInputresult() {
    this.removeAttribute('loading');
    this.ajaxInputText(this.querySelector('[data-search-ajax-live-region-count-value]').textContent);
  }

  ajaxOpen() {
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(ajaxCondRemove = false) {
    this.clearInput(ajaxCondRemove);
    this.isOpen = false;
  }

  clearInput(ajaxCondRemove = false) {
    if (ajaxCondRemove) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');
    if (selected) selected.setAttribute('aria-selected', false);
    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
  }
}

customElements.define('search-ajax', AjaxSearch);
